import escapeHtml from './escapeUtil'

const insertTagFromHighlightingMap = (text: string, map: Record<number, string>) => {
  const highlightingPositions = Object.keys(map)
    .map((key) => parseInt(key, 10))
    .sort((a, b) => a - b)

  let result = ''
  let lastIndex = 0

  highlightingPositions
    .filter((position) => position < text.length)
    .forEach((position) => {
      result += escapeHtml(text.substring(lastIndex, position))
      result += map[position]
      lastIndex = position
    })

  if (lastIndex < text.length) {
    result += escapeHtml(text.substring(lastIndex))
  }

  return result
}

export default insertTagFromHighlightingMap
